import React, { SVGProps } from 'react';

const ResponsibleGamblingIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="100%"
			height="100%"
			viewBox="0 0 17 17"
			fill="none"
			{...props}
		>
			<g clipPath="url(#clip0_24474_77240)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M15.2704 9.29374C17.1702 7.47987 17.1702 4.52184 15.2704 2.70797C13.5606 1.07666 10.8072 1.07665 9.0974 2.70796L8.92376 2.87373L8.74964 2.70764C7.03986 1.07642 4.28749 1.0767 2.57774 2.70799C0.677307 4.52252 0.677042 7.4799 2.57796 9.29393L8.92408 15.351L15.2704 9.29374ZM8.9143 9.64403C8.80715 9.73331 8.68215 9.78689 8.53929 9.78689H8.52143C8.37857 9.78689 8.23571 9.71546 8.14642 9.60831L6.48568 7.76899L7.28926 7.05469L8.59286 8.50115L10.0393 7.12612L11.4858 5.75109L12.2179 6.53682L10.5661 8.09042L8.9143 9.64403Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_24474_77240">
					<rect
						width="16"
						height="16"
						fill="white"
						transform="translate(0.900391 0.359375)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default ResponsibleGamblingIcon;
